export default __webpack_public_path__ + "static/media/uv11_kr_head_a1.edc9fd07.mp3";